import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { CellContext } from '@tanstack/react-table';

interface EmspBoChargingSessionListLocationOwnerNameCellProps
  extends CellContext<
    GatewayChargingSessionModel,
    GatewayChargingSessionModel['locationOwnerName']
  > {}

export const EmspBoChargingSessionListLocationOwnerNameCell = ({
  getValue,
}: EmspBoChargingSessionListLocationOwnerNameCellProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const value = getValue();

  // RENDER ////////////////////////////////////////////////////////////////////

  if (value === undefined || value === null) {
    return <span>—</span>;
  }

  return <Text truncate>{value}</Text>;
};
